export default {
  ApiBaseUrl: process.env.REACT_APP_API_BASE_URL || 'http://localhost:1337',
};
